const GET_CHECKOUT_DETAILS = 'GET_CHECKOUT_DETAILS';
const GET_CHECKOUT_DETAILS_SUCCESS = 'GET_CHECKOUT_DETAILS_SUCCESS';
const GET_CHECKOUT_DETAILS_ERROR = 'GET_CHECKOUT_DETAILS_ERROR';
const GET_CHECKOUT_DETAILS_RESPONSE = 'GET_CHECKOUT_DETAILS_RESPONSE';
const ASYNC_FETCH_SUCCESS = 'ASYNC_FETCH_SUCCESS';
const CEF_CHECKOUT_DETAILS_ERROR = 'CEF_CHECKOUT_DETAILS_ERROR';

export {
  GET_CHECKOUT_DETAILS,
  GET_CHECKOUT_DETAILS_SUCCESS,
  GET_CHECKOUT_DETAILS_ERROR,
  GET_CHECKOUT_DETAILS_RESPONSE,
  ASYNC_FETCH_SUCCESS,
  CEF_CHECKOUT_DETAILS_ERROR,
};
